import {
  Collection,
  CollectionFeeDetailFragment,
  Maybe,
  UserCartStoreItemPurchaseConfirmationFragment,
  UserCartStoreItemPurchaseProceedFragment,
} from '@/clients/utoniq-core/schema'

/**
 * アイテム・SKUの配列をコレクション単位でまとめる
 *
 * @returns {
 *  collection: Collection,
 *  items: Item[]
 *  eventCollection: EventCollectionBoxFragment
 * }
 */

export const groupItemsByCollection = (
  cartItems:
    | UserCartStoreItemPurchaseProceedFragment['items']
    | UserCartStoreItemPurchaseConfirmationFragment['items']
) => {
  if (!cartItems) return null

  const collections = cartItems.map(cartItem => cartItem.item.collection)
  const uniqueCollections = collections.filter((collection, index) => {
    return (
      collections.findIndex(element => element?.id === collection?.id) === index
    )
  })
  return (
    uniqueCollections
      .map(collection => ({
        collection,
        items: cartItems.filter(
          cartItem => cartItem.item.collection?.id === collection?.id
        ),
        eventCollection: collection?.event?.eventCollections?.edges?.find(
          ({ node }) => node.collectionId === collection.id
        )?.node,
      }))
      // collection: nullのアイテムを先頭に配置
      .sort((a, b) => {
        if (a.collection === null) return -1
        if (b.collection === null) return 1
        return 0
      })
  )
}

/**
 * add collection to collection fee
 * @param collectionFees
 * @param collections
 */
export const addCollectionToCollectionFee = (
  collectionFees: Maybe<Maybe<CollectionFeeDetailFragment>[]> | undefined,
  collections?: Maybe<Pick<Collection, 'id' | 'title'> | undefined>[]
): Maybe<CollectionFeeDetailFragment>[] => {
  if (!collectionFees?.length) return []
  return collectionFees.map(fee => {
    if (!fee) return fee
    return {
      ...fee,
      collectionFee:
        collections?.find(
          collection => collection?.id === fee.id?.split(':')?.[0]
        ) ?? null,
    }
  })
}
